/**
 * Created by Jan on 07.04.2017.
 */

/**
 * Provides a fallback to prevent errors in console in non-mobile environments.
 *
 * Note: Cannot be namespaced (e.g. Lfl.MobileCallbacks) because of the way how objects are defined on Android.  
 */

if (typeof MobileCallbacks === 'undefined') {
    MobileCallbacks = {
        isMobile: function () {
            return false;
        },
        mobilePlatform: function () {
            return "none";
        }
    };
}
